// Shim for the 'react-native' → 'react-native-web' alias used in Expo web builds.
//
// Re-exports everything from react-native-web, plus polyfills ViewPropTypes
// which was removed in react-native-web 0.19.x but is still imported by
// react-native-calendars@1.19.4. Without this, the app crashes on load with:
// "Cannot read properties of undefined (reading 'style')"
//
// This file ONLY replaces the exact 'react-native' import alias (regex: react-native$).
// Deep imports like 'react-native-web/dist/exports/Platform' are unaffected.
module.exports = require('react-native-web');
module.exports.ViewPropTypes = require('deprecated-react-native-prop-types').ViewPropTypes;
